var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.676 7.32261C38.1497 2.79561 31.9065 0 24.9992 0C18.092 0 11.8491 2.79561 7.32261 7.3225C2.79613 11.8492 0 18.0918 0 24.9991C0 31.9061 2.79613 38.1493 7.32261 42.6757C11.8491 47.2026 18.0919 49.998 24.9992 49.998C31.9065 49.998 38.1497 47.2026 42.676 42.6757C47.2025 38.1493 49.999 31.9061 49.999 24.9991C49.999 18.0919 47.2026 11.8493 42.676 7.32261ZM41.306 41.3053C37.1257 45.4723 31.3666 48.0468 24.9992 48.0468C18.6321 48.0468 12.8733 45.4723 8.70681 41.3053C4.54002 37.1253 1.95165 31.3668 1.95165 24.9992C1.95165 18.6319 4.54002 12.8733 8.70681 8.70681C12.8733 4.54033 18.6321 1.95144 24.9992 1.95144C31.3666 1.95144 37.1257 4.54033 41.306 8.70681C45.4725 12.8733 48.0471 18.6319 48.0471 24.9992C48.0471 31.3668 45.4725 37.1253 41.306 41.3053Z",
    fill: "url(#paint0_linear_214_886)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.676 7.32261C38.1497 2.79561 31.9065 0 24.9992 0C18.092 0 11.8491 2.79561 7.32261 7.3225C2.79613 11.8492 0 18.0918 0 24.9991C0 31.9061 2.79613 38.1493 7.32261 42.6757C11.8491 47.2026 18.0919 49.998 24.9992 49.998C31.9065 49.998 38.1497 47.2026 42.676 42.6757C47.2025 38.1493 49.999 31.9061 49.999 24.9991C49.999 18.0919 47.2026 11.8493 42.676 7.32261ZM41.306 41.3053C37.1257 45.4723 31.3666 48.0468 24.9992 48.0468C18.6321 48.0468 12.8733 45.4723 8.70681 41.3053C4.54002 37.1253 1.95165 31.3668 1.95165 24.9992C1.95165 18.6319 4.54002 12.8733 8.70681 8.70681C12.8733 4.54033 18.6321 1.95144 24.9992 1.95144C31.3666 1.95144 37.1257 4.54033 41.306 8.70681C45.4725 12.8733 48.0471 18.6319 48.0471 24.9992C48.0471 31.3668 45.4725 37.1253 41.306 41.3053Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.087 17.8429C27.087 16.86 27.5598 16.4554 28.0311 16.4554H31.0464V11.9751H26.9509C22.563 11.9751 21.4606 15.4894 21.4606 17.5937V19.5812H18.96V24.5825H21.4606V37.7109H27.087V24.5825H30.4947L30.6609 22.6287L30.9656 19.5812H27.087V17.8429Z",
    fill: "url(#paint1_linear_214_886)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.087 17.8429C27.087 16.86 27.5598 16.4554 28.0311 16.4554H31.0464V11.9751H26.9509C22.563 11.9751 21.4606 15.4894 21.4606 17.5937V19.5812H18.96V24.5825H21.4606V37.7109H27.087V24.5825H30.4947L30.6609 22.6287L30.9656 19.5812H27.087V17.8429Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_886",
    x1: 0,
    y1: 24.999,
    x2: 49.999,
    y2: 24.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#35B8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_886",
    x1: 18.96,
    y1: 24.843,
    x2: 31.0464,
    y2: 24.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#35B8A3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4515d6af556224828333c57cd88a2b61.svg";
export { ForwardRef as ReactComponent };